﻿import Storage from "../utilities/storage";
import $ from 'jquery';
import Url from "../utilities/url";
import "./remote/remote";
import { StringExtensions } from "../utilities/extensions";
declare global {
  interface JQuery {
    thumbnaildownloader: (options, args) => any;
  }
}

export class ThumbnailDownloader {
  public static get wireup(): string { return this.attributeKey.asDataSelector(); }
  public static get attributeKey(): string { return 'thumbnail-url'; }

  private $element: JQuery;
  private url: string;

  public constructor($element: JQuery) {
    if (!$element || $element.length != 1)
      throw new Error('You must provide a single element to Rustig.ThumbnailDownloader');

    this.$element = $element;
    this.url = this.$element.data(ThumbnailDownloader.attributeKey);

    let thumbnailWasInCache = this.trySetThumbnailFromCache();
    if (!thumbnailWasInCache)
      this.downloadThumbnail();
  }

  public trySetThumbnailFromCache(): boolean {
    let value = Storage.get(this.url);

    if (StringExtensions.isNullOrWhitespace(value))
      return false;

    ThumbnailDownloader.setSrc(this.$element, value);
    return true;
  }

  public downloadThumbnail(): void {
    this.$element.remote({ url: this.url });
  }

  public static setThumbnail(data: IThumbnailDownloaderData): void {
    let url = new Url(data.url)
      .setProtocol('')
      .setHost('')
      .setPort('')
      .removeQueryParameter('_')
      .toUrl();

    if (data.shouldCacheThumbnail) {
      let sevenDays = 604800000;
      Storage.set(url, data.src, sevenDays);
    }

    let $element = $(ThumbnailDownloader.attributeKey.asDataSelector(url));
    ThumbnailDownloader.setSrc($element, data.src);
  }

  private static setSrc($element: JQuery, src: string): void {
    if ($element.is('img'))
      $element.attr('src', src);
    else
      $element.find('img').attr('src', src);

    $element.find('[data-td-retrieving]').remove();
  }
}

export interface IThumbnailDownloaderData {
  url: string;
  src: string;
  shouldCacheThumbnail: boolean;
}

function Plugin(option, args) {
  return this.each(function () {
    let $this = $(this);
    let data = $this.data('rustig.thumbnaildownloader');
    let options = typeof option == 'object' && option;

    if (!data) {
      data = new ThumbnailDownloader($this);
      $this.data('rustig.thumbnaildownloader', data);
    }
    if (typeof option == 'string')
      data[option](args);
  });
}

$.fn.thumbnaildownloader = Plugin;
